import {
  setReports,
  setReportsToJob,
  setReportsToDealers,
  setReportsToEmployees,
} from '../../store/actions'

const mapStateToProps = (state) => ({
  jobReports: state.reports.reports.counting_job_report,
  dealerReports: state.reports.reports.dealer_report,
  employeeReports: state.reports.reports.user_report,
  listJobReports: state.reports.jobReports,
  listDealerReports: state.reports.dealersReports,
  listUserReports: state.reports.userReports,
  startDateReport: state.reports.startDateReport,
  endDateReport: state.reports.endDateReport
})

const mapDispatchToProps = {
  setReports,
  setReportsToJob,
  setReportsToDealers,
  setReportsToEmployees,
}

export {
  mapStateToProps,
  mapDispatchToProps,
}
